import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./App.css";
import * as Sentry from "@sentry/browser";

import { Provider } from "react-redux";

import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";

import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { DSN } from "./config.js";

import freshpaintReducer from "./reducers";
import { FPAlertProvider } from "./AlertProvider";

const reduxMiddleware = compose(
  applyMiddleware(thunk),
  window.devToolsExtension ? window.devToolsExtension() : (f) => f
);

const store = createStore(freshpaintReducer, reduxMiddleware);

Sentry.init({ dsn: DSN });

const Root = () => (
  <Provider store={store}>
    <FPAlertProvider>
      <App />
    </FPAlertProvider>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
